import React, { useState, useCallback, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  PageContainer,
  ModelSelectorAndRecentActivityContainer,
  NotesAndTasksContainer,
  RepairOrdersAndAppointmentsContainer,
  WidgetGridContainer,
  Container,
} from "./Overview.styled";
import {
  InformationCards,
  ModelSelector,
  RecentActivity,
  Notes,
  Tasks,
  RepairOrders,
  Appointments,
} from "./components";
import {
  WidgetGridProvider,
  WidgetGrid,
  DashboardSelector,
  useDashboardList,
  CONTEXT_ENTITIES,
} from "../../../../../components/WidgetGrid";
import { useStore } from "../../../../../hooks";
import NotesSlideOut from "../Activity/components/PreviewSlideOut/NotesSlideOut";
import { useActivitySnapshot } from "../../hooks/useActivitySnapshot";

const Overview = () => {
  const { authStore } = useStore();
  const { contactId } = useParams();
  const navigate = useNavigate();
  const [isCreateNoteOpen, setIsCreateNoteOpen] = useState(false);

  const { handleCreateNote } = useActivitySnapshot();

  const {
    dashboards,
    selectedUuid: dashboardUuid,
    selectDashboard,
    loading: dashboardListLoading,
  } = useDashboardList({ scopeType: 'CONTACT', module: 'OVERVIEW' });

  const scopeContext = useMemo(
    () => ({ contact_id: contactId }),
    [contactId],
  );
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const handleSelectedVehicleChange = useCallback((vehicle) => {
    setSelectedVehicle(vehicle);
  }, []);

  const handleWidgetNavigate = useCallback(
    (path) => {
      const fullPath = path.startsWith("/")
        ? path
        : `/v2/ucp/${contactId}/${path}`;
      navigate(fullPath);
    },
    [contactId, navigate]
  );

  const handleOpenCreateNote = useCallback(() => {
    setIsCreateNoteOpen(true);
  }, []);

  const handleCloseCreateNote = useCallback(() => {
    setIsCreateNoteOpen(false);
  }, []);

  return (
    <PageContainer>
      <Container>
        <InformationCards />
        {contactId && dashboardUuid && (
          <WidgetGridContainer>
            <WidgetGridProvider
              scopeType="CONTACT"
              module="OVERVIEW"
              scopeContext={scopeContext}
              contextEntity={CONTEXT_ENTITIES.CONTACT}
              contextId={contactId}
              userId={authStore.userId ?? ''}
              onNavigate={handleWidgetNavigate}
              onCreateNoteClick={handleOpenCreateNote}
            >
              <DashboardSelector
                dashboards={dashboards}
                selectedUuid={dashboardUuid}
                onSelect={selectDashboard}
                loading={dashboardListLoading}
              />
              <WidgetGrid dashboardUuid={dashboardUuid} />
            </WidgetGridProvider>
          </WidgetGridContainer>
        )}
        <ModelSelectorAndRecentActivityContainer>
          <ModelSelector 
            contactId={contactId} 
            onSelectedVehicleChange={handleSelectedVehicleChange}
          />
          <RecentActivity />
        </ModelSelectorAndRecentActivityContainer>
        <NotesAndTasksContainer>
          <Notes />
          <Tasks />
        </NotesAndTasksContainer>
        <RepairOrdersAndAppointmentsContainer>
          <RepairOrders />
          <Appointments />
        </RepairOrdersAndAppointmentsContainer>
        {/* <DealershipTeamAndFISalesContainer>
          <DealershipTeam />
          <FISales contactId={contactId} selectedVehicle={selectedVehicle} />
        </DealershipTeamAndFISalesContainer> */}
      </Container>

      <NotesSlideOut
        open={isCreateNoteOpen}
        onClose={handleCloseCreateNote}
        mode="create"
        onCreateNote={handleCreateNote}
      />
    </PageContainer>
  );
};

export default Overview;
